import BacktoTopButton from '@/components/atoms/buttons/BacktoTopButton'
import styles from './style.module.scss'

export default function NotFound() {
  return (
    <div>
      <section className="contents">
        <div className="inner">
          <div className={styles.notfound}>
            <div className={styles.notfoundNumber}>404</div>

            <h1>お探しのページは見つかりませんでした。</h1>

            <p>URLが変更されたか、ページが削除された可能性があります。</p>

            <BacktoTopButton />
          </div>
        </div>
      </section>
    </div>
  )
}
